// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';


var angularLogo = (require('./assets/logos/angular.png'));

var bootstrapLogo = (require('./assets/logos/bootstrap.png'));

var cplusplusLogo = (require('./assets/logos/cplusplus.png'));

var cssLogo = (require('./assets/logos/css.png'));

var expressLogo = (require('./assets/logos/express.png'));

var gruntLogo = (require('./assets/logos/grunt.png'));

var gulpLogo = (require('./assets/logos/gulp.png'));

var html5Logo = (require('./assets/logos/html5.png'));

var jasmineLogo = (require('./assets/logos/jasmine.png'));

var javaLogo = (require('./assets/logos/java.png'));

var javascriptLogo = (require('./assets/logos/javascript.png'));

var jqueryLogo = (require('./assets/logos/jquery.png'));

var karmaLogo = (require('./assets/logos/karma.png'));

var lessLogo = (require('./assets/logos/less.png'));

var nodeLogo = (require('./assets/logos/node.png'));

var pugLogo = (require('./assets/logos/pug.png'));

var pythonLogo = (require('./assets/logos/python.png'));

var reactLogo = (require('./assets/logos/react.png'));

var reduxLogo = (require('./assets/logos/redux.png'));

var sassLogo = (require('./assets/logos/sass.png'));

var springLogo = (require('./assets/logos/spring.png'));

var typescriptLogo = (require('./assets/logos/typescript.png'));

var vueLogo = (require('./assets/logos/vue.png'));

var webpackLogo = (require('./assets/logos/webpack.png'));

function get(logoName) {
  switch (logoName) {
    case "angularLogo" :
        return angularLogo;
    case "bootstrapLogo" :
        return bootstrapLogo;
    case "cplusplusLogo" :
        return cplusplusLogo;
    case "cssLogo" :
        return cssLogo;
    case "expressLogo" :
        return expressLogo;
    case "gruntLogo" :
        return gruntLogo;
    case "gulpLogo" :
        return gulpLogo;
    case "html5Logo" :
        return html5Logo;
    case "jasmineLogo" :
        return jasmineLogo;
    case "javaLogo" :
        return javaLogo;
    case "javascriptLogo" :
        return javascriptLogo;
    case "jqueryLogo" :
        return jqueryLogo;
    case "karmaLogo" :
        return karmaLogo;
    case "lessLogo" :
        return lessLogo;
    case "nodeLogo" :
        return nodeLogo;
    case "pugLogo" :
        return pugLogo;
    case "pythonLogo" :
        return pythonLogo;
    case "reactLogo" :
        return reactLogo;
    case "reduxLogo" :
        return reduxLogo;
    case "sassLogo" :
        return sassLogo;
    case "springLogo" :
        return springLogo;
    case "typescriptLogo" :
        return typescriptLogo;
    case "vueLogo" :
        return vueLogo;
    case "webpackLogo" :
        return webpackLogo;
    default:
      return "";
  }
}

exports.angularLogo = angularLogo;
exports.bootstrapLogo = bootstrapLogo;
exports.cplusplusLogo = cplusplusLogo;
exports.cssLogo = cssLogo;
exports.expressLogo = expressLogo;
exports.gruntLogo = gruntLogo;
exports.gulpLogo = gulpLogo;
exports.html5Logo = html5Logo;
exports.jasmineLogo = jasmineLogo;
exports.javaLogo = javaLogo;
exports.javascriptLogo = javascriptLogo;
exports.jqueryLogo = jqueryLogo;
exports.karmaLogo = karmaLogo;
exports.lessLogo = lessLogo;
exports.nodeLogo = nodeLogo;
exports.pugLogo = pugLogo;
exports.pythonLogo = pythonLogo;
exports.reactLogo = reactLogo;
exports.reduxLogo = reduxLogo;
exports.sassLogo = sassLogo;
exports.springLogo = springLogo;
exports.typescriptLogo = typescriptLogo;
exports.vueLogo = vueLogo;
exports.webpackLogo = webpackLogo;
exports.get = get;
/* angularLogo Not a pure module */
